// DesbloquearNivelesPage.jsx
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import {
  Container,
  Typography,
  Card,
  CardContent,
  CardHeader,
  Button,
  Box,
  Chip,
  Paper,
  Grid,
  Fade,
  Divider
} from '@mui/material';
import {
  ArrowForward,
  ArrowBack,
  CheckCircle,
  Lock,
  LockOpen,
  HowToReg
} from '@mui/icons-material';

// Colores de Alianza Social
const alianzaColors = {
  primary: '#1E88E5',
  secondary: '#E63946',
  yellow: '#FFC107',
  orange: '#FF9800',
  green: '#4CAF50',
  purple: '#9C27B0',
  darkGrey: '#424242',
  lightGrey: '#BDBDBD'
};

const DesbloquearNivelesPage = () => {
  const navigate = useNavigate();
  const [selectedNivel, setSelectedNivel] = useState(0); // Nivel 1 seleccionado por defecto

  const niveles = [
    {
      id: 1,
      emoji: '🌱',
      title: 'Simpatizante',
      subtitle: 'Nivel 1',
      chip: 'ABIERTO',
      chipColor: alianzaColors.green,
      color: alianzaColors.green,
      desc: 'Apoyas el movimiento sin compromiso formal. Puedes votar por nuestros candidatos y asistir a eventos públicos.',
      items: [
        'Acceso a información y eventos públicos',
        'Derecho a voto por candidatos de Alianza Social',
        'Sin obligaciones de militancia',
        'Recibir boletines informativos'
      ],
      btnText: 'Ya soy simpatizante ✓',
      estado: 'activo'
    },
    {
      id: 2,
      emoji: '💥',
      title: 'Afiliado',
      subtitle: 'Nivel 2',
      chip: 'DESBLOQUEABLE',
      chipColor: alianzaColors.purple,
      color: alianzaColors.purple,
      desc: 'Inscripción formal al movimiento con derechos de participación en decisiones internas.',
      items: [
        'Participar en asambleas y consultas internas',
        'Elegir y ser elegido en cargos internos',
        'Acceso a capacitaciones exclusivas',
        'Voz y voto en decisiones del movimiento',
        'Carnet de afiliado oficial'
      ],
      reqs: [
        'Llenar formulario de inscripción',
        'Asistir a sesión de inducción',
        'Aceptar estatutos y principios del movimiento',
        'Presentar documento de identidad'
      ],
      btnText: 'Desbloquear Afiliado',
      estado: 'desbloqueable'
    },
    {
      id: 3,
      emoji: '🚀',
      title: 'Militante Activo',
      subtitle: 'Nivel 3',
      chip: 'DESBLOQUEABLE',
      chipColor: alianzaColors.primary,
      color: alianzaColors.primary,
      desc: 'Compromiso activo con trabajo regular en comités, campañas y movilización.',
      items: [
        'Liderar comités temáticos o territoriales',
        'Coordinar campañas y eventos',
        'Capacitaciones avanzadas en liderazgo',
        'Representar al movimiento públicamente',
        'Acceso a red de militantes nacionales',
        'Certificaciones oficiales de formación'
      ],
      reqs: [
        'Ser afiliado activo por mínimo 6 meses',
        'Completar curso de formación política',
        'Participar en al menos 3 actividades del movimiento',
        'Presentar propuesta de proyecto o iniciativa social',
        'Carta de recomendación de 2 afiliados'
      ],
      btnText: 'Desbloquear Militante',
      estado: 'desbloqueable'
    },
    {
      id: 4,
      emoji: '⭐',
      title: 'Directivo',
      subtitle: 'Nivel 4',
      chip: 'POR ELECCIÓN',
      chipColor: alianzaColors.orange,
      color: alianzaColors.orange,
      desc: 'Líderes elegidos para administrar y dirigir el movimiento en distintos niveles.',
      items: [
        'Tomar decisiones estratégicas del movimiento',
        'Administrar recursos y proyectos',
        'Representar oficialmente a Alianza Social',
        'Coordinar estructuras territoriales',
        'Participar en Directorio Nacional o Regional',
        'Acceso a información estratégica'
      ],
      reqs: [
        'Ser elegido por Asamblea correspondiente',
        'Demostrar liderazgo y compromiso sostenido',
        'Tener respaldo de la comunidad o territorio',
        'Cumplir con código ético del movimiento',
        'Experiencia mínima de 1 año como militante activo'
      ],
      btnText: 'Postularme como Directivo',
      estado: 'bloqueado'
    },
    {
      id: 5,
      emoji: '🏆',
      title: 'Candidato',
      subtitle: 'Nivel 5',
      chip: 'REQUIERE AVAL',
      chipColor: alianzaColors.secondary,
      color: alianzaColors.secondary,
      desc: 'Persona avalada por el movimiento para competir por cargos de elección popular.',
      items: [
        'Representar a Alianza Social ante la ciudadanía',
        'Recibir apoyo financiero en campaña',
        'Acceso a asesoría estratégica y logística',
        'Visibilidad y respaldo del movimiento',
        'Equipo de campaña asignado',
        'Capacitación en comunicación política'
      ],
      reqs: [
        'Ser afiliado en buen estado',
        'Superar consulta interna o proceso de selección',
        'Aprobación del Directorio correspondiente',
        'Cumplir requisitos legales ante CNE',
        'Presentar plan de gobierno o propuestas',
        'Examen de idoneidad ética'
      ],
      btnText: 'Solicitar Aval como Candidato',
      estado: 'bloqueado'
    }
  ];

  const nivelActual = niveles[selectedNivel];

  const handleNivelClick = (index) => {
    setSelectedNivel(index);
  };

  const handleButtonClick = () => {
    console.log(`Acción para nivel: ${nivelActual.title}`);
    if (nivelActual.id === 1) {
      navigate('/register');
    } else {
      alert(`Funcionalidad en desarrollo para: ${nivelActual.title}`);
    }
  };

  return (
    <Box 
      sx={{ 
        minHeight: '100vh', 
        py: 4,
        px: 2,
        width: '100%',
        maxWidth: '100%',
        display: 'block',
        overflow: 'hidden'
      }}
    >
      {/* <Container maxWidth="xl" fixed> */}
      <Container 
        maxWidth="xl" 
        sx={{ 
          width: '100%', 
          maxWidth: '100%',
          display: 'block', // ← Asegura block
          overflow: 'hidden' 
        }}
      >
        {/* Contenedor principal con estilo Alianza */}
        <Card
          sx={{
            backgroundColor: 'rgba(255, 255, 255, 0.35)',
            backdropFilter: 'blur(10px)',
            borderRadius: '24px',
            boxShadow: '0 8px 32px rgba(0, 0, 0, 0.38)',
            overflow: 'hidden',
            mt: 4,
            width: '100%',
            maxWidth: '100%',
            boxSizing: 'border-box',
            display: 'block',
            position: 'relative'
          }}
        >
          {/* Header compacto estilo DashboardAnalitico */}
          <CardHeader
            avatar={
              <Box sx={{ fontSize: "40px" }}>🎯</Box>
            }
            title={
              <Typography variant="h4" fontWeight="bold" color="#1E88E5">
                Tu Camino en Alianza Social
              </Typography>
            }
            subheader="Sistema de niveles de participación y liderazgo"
            action={
              <Button
                variant="outlined"
                startIcon={<ArrowBack />}
                onClick={() => navigate('/home')}
                sx={{
                  borderRadius: '12px',
                  borderWidth: '2px',
                  borderColor: alianzaColors.primary,
                  color: alianzaColors.primary,
                  fontWeight: 600,
                  '&:hover': {
                    borderWidth: '2px',
                    borderColor: alianzaColors.secondary,
                    backgroundColor: `${alianzaColors.secondary}15`,
                    color: alianzaColors.secondary
                  }
                }}
              >
                Volver
              </Button>
            }
            sx={{
              '& .MuiCardHeader-title': { fontSize: '1.5rem' },
              pb: 2
            }}
          />
          
          <CardContent sx={{ 
            p: { xs: 3, md: 4 }, 
            pt: 0 
          }}>

            {/* Selector de Niveles - Vista Horizontal Interactiva */}
            <Box sx={{ mb: 4 }}>
              <Grid 
                container 
                spacing={2} 
                justifyContent="center" 
                alignItems="stretch"
                sx={{ mb: 2 }}
              >
                {niveles.map((nivel, index) => (
                  <Grid item xs={12} sm={6} md={2.4} key={nivel.id}>
                    <Card
                      onClick={() => handleNivelClick(index)}
                      sx={{
                        cursor: 'pointer',
                        height: '100%',
                        borderRadius: '16px',
                        border: selectedNivel === index 
                          ? `3px solid ${nivel.color}` 
                          : '3px solid transparent',
                        backgroundColor: selectedNivel === index 
                          ? 'rgba(255, 255, 255, 0.35)' 
                          : 'rgba(255, 255, 255, 0.8)',
                        backdropFilter: selectedNivel === index ? 'blur(10px)' : 'none',
                        transition: 'all 0.3s ease',
                        transform: selectedNivel === index ? 'scale(1.05)' : 'scale(1)',
                        boxShadow: selectedNivel === index 
                          ? '0 8px 32px rgba(0, 0, 0, 0.38)' 
                          : '0 2px 8px rgba(0,0,0,0.1)',
                        '&:hover': {
                          transform: 'scale(1.08)',
                          boxShadow: `0 12px 28px ${nivel.color}50`
                        }
                      }}
                    >
                      <CardContent sx={{ 
                        textAlign: 'center', 
                        p: { xs: 1.5, md: 2 },
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                        justifyContent: 'center',
                        height: '100%'
                      }}>
                        {/* Emoji grande */}
                        <Box 
                          sx={{ 
                            fontSize: { xs: '2rem', md: '2.5rem' },
                            mb: 1,
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            width: { xs: 50, md: 60 },
                            height: { xs: 50, md: 60 },
                            borderRadius: '50%',
                            backgroundColor: selectedNivel === index 
                              ? `${nivel.color}25` 
                              : 'rgba(0,0,0,0.05)',
                            transition: 'all 0.3s'
                          }}
                        >
                          {nivel.emoji}
                        </Box>
                        
                        {/* Número de nivel */}
                        <Typography 
                          variant="caption" 
                          sx={{ 
                            fontWeight: 'bold',
                            color: nivel.color,
                            mb: 0.5,
                            fontSize: { xs: '0.7rem', md: '0.75rem' }
                          }}
                        >
                          {nivel.subtitle}
                        </Typography>
                        
                        {/* Título */}
                        <Typography 
                          variant="body1" 
                          sx={{ 
                            fontWeight: 'bold',
                            color: selectedNivel === index ? nivel.color : alianzaColors.darkGrey,
                            mb: 1,
                            fontSize: { xs: '0.85rem', md: '0.95rem' }
                          }}
                        >
                          {nivel.title}
                        </Typography>
                        
                        {/* Chip de estado */}
                        <Chip
                          label={nivel.chip}
                          size="small"
                          icon={
                            nivel.estado === 'activo' ? <CheckCircle /> :
                            nivel.estado === 'desbloqueable' ? <LockOpen /> :
                            <Lock />
                          }
                          sx={{
                            bgcolor: `${nivel.color}20`,
                            color: nivel.color,
                            fontWeight: 'bold',
                            fontSize: { xs: '0.65rem', md: '0.7rem' },
                            height: { xs: 22, md: 24 },
                            '& .MuiChip-icon': {
                              fontSize: { xs: '0.9rem', md: '1rem' }
                            }
                          }}
                        />
                      </CardContent>
                    </Card>
                  </Grid>
                ))}
              </Grid>

              {/* Indicador visual de progresión */}
              <Box 
                sx={{ 
                  display: { xs: 'none', md: 'flex' },
                  justifyContent: 'center',
                  alignItems: 'center',
                  gap: 1,
                  mt: 1.5
                }}
              >
                {niveles.map((nivel, index) => (
                  <React.Fragment key={nivel.id}>
                    <Box
                      sx={{
                        width: 12,
                        height: 12,
                        borderRadius: '50%',
                        bgcolor: selectedNivel === index ? nivel.color : '#E0E0E0',
                        transition: 'all 0.3s'
                      }}
                    />
                    {index < niveles.length - 1 && (
                      <Box
                        sx={{
                          width: 40,
                          height: 3,
                          bgcolor: selectedNivel > index ? niveles[index + 1].color : '#E0E0E0',
                          transition: 'all 0.3s'
                        }}
                      />
                    )}
                  </React.Fragment>
                ))}
              </Box>
            </Box>

            <Divider sx={{ mb: 3 }} />

            {/* Detalles del Nivel Seleccionado */}
            <Fade in={true} timeout={500} key={selectedNivel}>
              <Box sx={{ display: 'flex', justifyContent: 'center', width: '100%' }}>
                <Box sx={{ width: '100%', maxWidth: 1100 }}>
                  <Grid container spacing={3} sx={{ 
                    width: '100%', 
                    margin: 0,
                    minWidth: 0,
                    flexWrap: 'wrap',
                    '& .MuiGrid-item': {
                      minWidth: 0  // Esto es clave para los items del Grid
                    }
                  }}>
                    {/* Columna Izquierda - Info Principal */}
                    <Grid item xs={12} md={6} lg={8}
                      sx={{ 
                      flex: '1 1 0', 
                      minWidth: 0, 
                      maxWidth: '100%', 
                      width: '100%' 
                    }}>
                    <Card
                      sx={{
                        borderRadius: '16px',
                        border: `3px solid ${nivelActual.color}`,
                        backgroundColor: 'rgba(255, 255, 255, 0.35)',
                        backdropFilter: 'blur(10px)',
                        boxShadow: '0 8px 32px rgba(0, 0, 0, 0.38)',
                        height: '100%',
                        width: '100%',
                        maxWidth: '100%', // ← NUEVO
                        boxSizing: 'border-box', // ← NUEVO
                        minWidth: 0,
                        overflow: 'hidden',
                        display: 'flex',
                        flexDirection: 'column'
                      }}
                    >
                      <CardContent sx={{ 
                        p: 3,
                        // Añadir estas propiedades
                        width: '100%',
                        maxWidth: '100%',
                        boxSizing: 'border-box' 
                      }}>
                        {/* Header del nivel */}
                        <Box sx={{ display: 'flex', alignItems: 'center', mb: 2, gap: 2 }}>
                          <Box 
                            sx={{ 
                              fontSize: '2.5rem',
                              display: 'flex',
                              alignItems: 'center',
                              justifyContent: 'center',
                              width: 70,
                              height: 70,
                              borderRadius: '50%',
                              backgroundColor: `${nivelActual.color}20`,
                            }}
                          >
                            {nivelActual.emoji}
                          </Box>
                          <Box sx={{ flex: 1 }}>
                            <Typography 
                              variant="h5" 
                              sx={{ 
                                fontWeight: 'bold',
                                color: nivelActual.color,
                                mb: 0.5
                              }}
                            >
                              {nivelActual.title}
                            </Typography>
                            <Chip
                              label={nivelActual.chip}
                              icon={
                                nivelActual.estado === 'activo' ? <CheckCircle /> :
                                nivelActual.estado === 'desbloqueable' ? <LockOpen /> :
                                <Lock />
                              }
                              sx={{
                                bgcolor: nivelActual.chipColor,
                                color: 'white',
                                fontWeight: 'bold'
                              }}
                            />
                          </Box>
                        </Box>

                        {/* Descripción */}
                        <Typography 
                          variant="body1" 
                          sx={{ 
                            mb: 2, 
                            color: alianzaColors.darkGrey,
                            lineHeight: 1.6,
                            fontSize: '0.95rem',
                            // Solución agresiva
                            whiteSpace: 'normal !important',
                            wordWrap: 'break-word !important',
                            overflowWrap: 'break-word !important',
                            wordBreak: 'break-word !important',
                            maxWidth: '100% !important',
                            display: 'block',
                            // Fuerza el ancho
                            width: '100%'
                          }}
                        >
                          {nivelActual.desc}
                        </Typography>

                        {/* Beneficios */}
                        <Box>
                          <Typography 
                            variant="h6" 
                            sx={{ 
                              fontWeight: 'bold', 
                              mb: 1.5,
                              color: nivelActual.color,
                              display: 'flex',
                              alignItems: 'center',
                              gap: 1,
                              fontSize: '1rem'
                            }}
                          >
                            <CheckCircle /> Beneficios
                          </Typography>
                          <Box component="ul" sx={{ pl: 2, m: 0 }}>
                            {nivelActual.items.map((item, idx) => (
                              <Box
                                component="li"
                                key={idx}
                                sx={{
                                  mb: 1,
                                  '&::marker': {
                                    color: nivelActual.color
                                  }
                                }}
                              >
                                <Typography variant="body2" sx={{ fontSize: '0.9rem', wordWrap: 'break-word', overflowWrap: 'break-word' }}>
                                  {item}
                                </Typography>
                              </Box>
                            ))}
                          </Box>
                        </Box>
                      </CardContent>
                    </Card>
                  </Grid>

                  {/* Columna Derecha - Requisitos y Acción */}
                  <Grid item xs={12} md={6} lg={4}
                    //   sx={{ 
                    //   flex: '1 1 0', 
                    //   minWidth: 0, 
                    //   maxWidth: '100%', 
                    //   width: '100%' 
                    // }}
                  >
                    {/* Requisitos */}
                    {nivelActual.reqs && (
                      <Card
                        sx={{
                          borderRadius: '16px',
                          backgroundColor: 'rgba(255, 255, 255, 0.35)',
                          backdropFilter: 'blur(10px)',
                          boxShadow: '0 8px 32px rgba(0, 0, 0, 0.38)',
                          mb: 2,
                          border: `2px solid ${nivelActual.color}40`,
                          width: '100%',
                          maxWidth: '100%', // ← NUEVO
                          boxSizing: 'border-box' // ← NUEVO
                        }}
                      >
                        <CardContent sx={{ p: 2.5 }}>
                          <Typography 
                            variant="h6" 
                            sx={{ 
                              fontWeight: 'bold', 
                              mb: 1.5,
                              color: nivelActual.color,
                              display: 'flex',
                              alignItems: 'center',
                              gap: 1,
                              fontSize: '1rem'
                            }}
                          >
                            📋 Requisitos para desbloquear
                          </Typography>
                          <Box component="ul" sx={{ pl: 2, m: 0 }}>
                            {nivelActual.reqs.map((req, idx) => (
                              <Box
                                component="li"
                                key={idx}
                                sx={{
                                  mb: 1,
                                  '&::marker': {
                                    color: nivelActual.color
                                  }
                                }}
                              >
                                <Typography variant="body2" sx={{ fontSize: '0.9rem', wordWrap: 'break-word', overflowWrap: 'break-word' }}>
                                  {req}
                                </Typography>
                              </Box>
                            ))}
                          </Box>
                        </CardContent>
                      </Card>
                    )}

                    {/* Botón de acción */}
                    <Card
                      sx={{
                        borderRadius: '16px',
                        backgroundColor: 'rgba(255, 255, 255, 0.35)',
                        backdropFilter: 'blur(10px)',
                        boxShadow: '0 8px 32px rgba(0, 0, 0, 0.38)',
                        border: `3px solid ${nivelActual.color}`,
                        position: 'relative',
                        overflow: 'hidden',
                        width: '100%'
                      }}
                    >
                      <CardContent sx={{ p: 3, position: 'relative', zIndex: 1 }}>
                        <Typography 
                          variant="h6" 
                          sx={{ 
                            fontWeight: 'bold',
                            color: nivelActual.color,
                            mb: 1.5,
                            textAlign: 'center',
                            fontSize: '1.1rem'
                          }}
                        >
                          {nivelActual.estado === 'activo' 
                            ? '¡Ya estás en este nivel!' 
                            : '¿Listo para dar el siguiente paso?'}
                        </Typography>
                        <Button
                          variant="contained"
                          fullWidth
                          size="large"
                          onClick={handleButtonClick}
                          startIcon={
                            nivelActual.estado === 'activo' ? <CheckCircle /> : <HowToReg />
                          }
                          sx={{
                            bgcolor: nivelActual.color,
                            color: 'white',
                            fontWeight: 'bold',
                            fontSize: '1rem',
                            py: 1.5,
                            borderRadius: '12px',
                            '&:hover': {
                              bgcolor: nivelActual.color,
                              filter: 'brightness(0.9)',
                              transform: 'scale(1.02)',
                              boxShadow: '0 8px 16px rgba(0,0,0,0.2)'
                            },
                            transition: 'all 0.3s'
                          }}
                        >
                          {nivelActual.btnText}
                        </Button>
                      </CardContent>
                    </Card>
                  </Grid>
                </Grid>
                </Box>
              </Box>
            </Fade>

            {/* Footer con llamado a la acción */}
            <Box 
              sx={{ 
                mt: 4,
                p: 3,
                borderRadius: '16px',
                background: `linear-gradient(45deg, ${alianzaColors.yellow}, ${alianzaColors.orange})`,
                textAlign: 'center',
                position: 'relative',
                overflow: 'hidden'
              }}
            >
              <Box sx={{ 
                position: 'absolute', 
                top: -50, 
                left: -50, 
                width: 150, 
                height: 150, 
                borderRadius: '50%', 
                background: 'rgba(255, 255, 255, 0.1)' 
              }} />
              <Box sx={{ 
                position: 'absolute', 
                bottom: -50, 
                right: -50, 
                width: 150, 
                height: 150, 
                borderRadius: '50%', 
                background: 'rgba(255, 255, 255, 0.1)' 
              }} />
              
              <Typography 
                variant="h5" 
                sx={{ 
                  fontWeight: 'bold', 
                  color: 'white', 
                  mb: 1.5,
                  textShadow: '2px 2px 4px rgba(0,0,0,0.2)',
                  position: 'relative',
                  zIndex: 1
                }}
              >
                💪 Comienza Tu Transformación Hoy
              </Typography>
              <Typography 
                variant="body2" 
                sx={{ 
                  color: 'white', 
                  mb: 2,
                  opacity: 0.95,
                  maxWidth: 600,
                  mx: 'auto',
                  position: 'relative',
                  zIndex: 1
                }}
              >
                Únete a miles de colombianos comprometidos con el cambio. Tu participación es clave para construir el país que soñamos.
              </Typography>
              <Button
                variant="contained"
                size="large"
                onClick={() => navigate('/register')}
                startIcon={<ArrowForward />}
                sx={{
                  bgcolor: 'white',
                  color: alianzaColors.orange,
                  fontWeight: 'bold',
                  fontSize: '1rem',
                  px: 4,
                  py: 1.2,
                  borderRadius: '12px',
                  position: 'relative',
                  zIndex: 1,
                  '&:hover': {
                    bgcolor: 'rgba(255,255,255,0.95)',
                    transform: 'scale(1.05)',
                    boxShadow: '0 8px 20px rgba(0,0,0,0.3)'
                  },
                  transition: 'all 0.3s'
                }}
              >
                Unirme a Alianza Social
              </Button>
            </Box>
          </CardContent>
        </Card>
      </Container>
    </Box>
  );
};

export default DesbloquearNivelesPage;